import React from 'react';
import { Input } from '../input';

export const TextboxWrapper = ({ register, name, title, subtitle, error, disabled, placeholder, responsiveClassName, onChange, value }) => {
  return (
    <div className={responsiveClassName}>
      {!!title && (
      <label htmlFor={name} className="block text-sm font-medium text-gray-700">
        {title}
      </label>
      )}
      {!!subtitle && (
      <p className="text-xs mt-1 mb-2 text-gray-500">
        {subtitle}
      </p>
      )}
      <div className="mt-1 relative rounded-md shadow-sm">
        <Input
          {...(register ? register(name) : {})}
          className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md placeholder-gray-400"
          id={name}
          type="text"
          errorMessage={error}
          disabled={disabled}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
        />
      </div>
      {error && (
      <p className="mt-2 text-sm text-red-600" id={`${name}-error`}>
        {error.message}
      </p>
      )}
    </div>
  );
};
